import { Controller } from "@hotwired/stimulus"

// Disables the submit button while the subtask title is empty or whitespace,
// and toggles the optional details panel (date / time / description).
// Server-side validation in Subtask still runs as a safety net.
export default class extends Controller {
  static targets = ["title", "submit", "details", "toggle"]

  // Mirrors Subtasks::MentionParser::FULL_REGEX (app/services/subtasks/mention_parser.rb):
  // the server strips "@First Last" mention tokens from the title before validating it,
  // so a title of only mentions ends up empty. Strip them here too, otherwise the guard
  // would keep submit enabled and the server re-renders a mis-aligned "title required" error.
  static MENTION_REGEX = /@\p{L}[\p{L}'-]*(?:\s+\p{L}[\p{L}'-]*)?/gu

  connect() {
    this.refresh()
  }

  refresh() {
    const empty = this.titleWithoutMentions().length === 0
    this.submitTarget.disabled = empty
    this.submitTarget.classList.toggle("opacity-50", empty)
    this.submitTarget.classList.toggle("cursor-not-allowed", empty)
    this.submitTarget.classList.toggle("cursor-pointer", !empty)
  }

  titleWithoutMentions() {
    return this.titleTarget.value.replace(this.constructor.MENTION_REGEX, " ").trim()
  }

  toggleDetails(event) {
    event.preventDefault()
    if (!this.hasDetailsTarget) return

    const open = this.detailsTarget.classList.toggle("hidden") === false
    if (this.hasToggleTarget) {
      this.toggleTarget.classList.toggle("text-green-600", open)
      this.toggleTarget.classList.toggle("bg-green-50", open)
      this.toggleTarget.setAttribute("aria-expanded", open ? "true" : "false")
    }
  }
}
